import React, { memo, useContext } from 'react';
import { Box, Typography } from '@common-ui/ui';
import { DocumentContext } from './ContextDocument';
import SectionTemplate from './SectionTemplate';

const TableOfContentsRow = memo(({ section, rowIndex, isSubsection = false }) => {
  const { name, pageNumber } = section;
  const paddingLeft = isSubsection ? '1rem' : '0';

  const dotLeaderStyle = {
    flexGrow: 1,
    height: '12px',
    borderBottom: '3px dotted gray',
  };

  return (
    <div key={pageNumber} style={{ display: 'flex', alignItems: 'center', paddingLeft }}>
      <Typography variant="subtitle3" style={{ marginRight: '0.5em' }}>
        {`${rowIndex}. ${name}`}
      </Typography>
      <span style={dotLeaderStyle} />
      <Typography variant="subtitle3" style={{ marginLeft: '0.5em' }}>
        {pageNumber}
      </Typography>
    </div>
  );
});

const TableOfContentsSection = memo(({ section, sectionIndex, showSubSection = false }) => {
  const { sections: subSections } = section;

  return (
    <>
      <TableOfContentsRow section={section} rowIndex={sectionIndex} />
      {subSections &&
        showSubSection &&
        subSections.map((subSection, subSectionIndex) => (
          <React.Fragment key={`${sectionIndex}.${subSectionIndex}`}>
            {subSection.name && (
              <TableOfContentsRow
                section={subSection}
                isSubsection={true}
                rowIndex={`${sectionIndex}.${subSectionIndex + 1}`}
              />
            )}
          </React.Fragment>
        ))}
    </>
  );
});

export default function TableOfContents({
  id = 'tableOfContents',
  name = 'Table Of Contents',
  metadata = {},
}) {
  const { sections } = useContext(DocumentContext);

  const styles = {
    sectionRow: {
      paddingBottom: '1em',
      paddingLeft: '2em',
      paddingRight: '2em',
    },
    column: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '1em',
    },
  };

  return (
    <>
      {sections && (
        <SectionTemplate id={id} name={name} metadata={metadata}>
          <Box mt={3} id={`table-of-contents-title`}>
            <Typography variant="h4">Table of Contents</Typography>
          </Box>

          {sections.map((section, sectionIndex) => (
            <div key={sectionIndex} style={styles.sectionRow}>
              <TableOfContentsSection
                key={`table-of-contents-${section.name}-${sectionIndex}`}
                section={section}
                sectionIndex={sectionIndex + 1}
                showSubSection={true}
              />
            </div>
          ))}
        </SectionTemplate>
      )}
    </>
  );
}
